/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
/* eslint-disable max-len */
import gsap from 'gsap/dist/gsap';
import noUiSlider from 'nouislider';
import {wordAnimation} from './word-animation';
import $ from 'jquery';

export function test() {
	const $document = $(document);
	const $containerApp = $('.beeline-test');
	const $test = $containerApp.find('.test');
	const $start = $test.find('.test__start');
	const $step = $test.find('.test__step');
	const $result = $test.find('.test__result');
	const $resultTitle = $result.find('.test__name');
	const $resultText = $result.find('.test__description');
	const $startButton = $test.find('.js-test-start');
	const $answerButton = $test.find('.js-test-answer');
	const $nextButton = $test.find('.js-test-next');
	const $reloadButton = $test.find('.js-test-reload');
	const $subTitleResult = $test.find('.test__result-title');
	const $subTextResult = $test.find('.test__result-text');
	const $resultImg = $test.find('.test__result-img');
	const $resultBottom = $test.find('.test__result-bottom');
	const $closeDescription = $test.find('.test__description-close');
	const answers = [];

	function getResultIndex(correctAnswersCount) {
		let index = null;

		if (correctAnswersCount > 21 && correctAnswersCount <= 37 || correctAnswersCount === 21 || correctAnswersCount === 37) {
			index = 1;
		} else if (correctAnswersCount > 38 && correctAnswersCount <= 50 || correctAnswersCount === 38 || correctAnswersCount === 50) {
			index = 2;
		} else {
			index = 0;
		}

		return index;
	}

	function setUrlParam(resetParams) {
		let answersNumber = sumResult(answers);
		let url = '';
		let resultParamExists = location.search.indexOf('result=') !== -1;
		$containerApp.attr('data-result', getResultIndex(answersNumber));
		console.log(getResultIndex(answersNumber));
		if (resetParams && resultParamExists) {
			url = location.origin + location.pathname;

			history.replaceState(null, null, url);
		} else if (!resetParams) {
			url = `${location.origin}${location.pathname}?result=${getResultIndex(answersNumber)}`;

			history.replaceState(null, null, url);
		}
	}

	function sumResult(arr) {
		return arr.reduce((total, value) => {
			return total + value;
		}, 0);
	}

	function reset() {
		$start.removeClass('is-hidden');
		$step.addClass('is-hidden').removeClass('is-done');
		$result.addClass('is-hidden');
		$resultTitle.addClass('is-hidden');
		$resultText.addClass('is-hidden');
		$subTitleResult.addClass('is-hidden');
		$subTextResult.addClass('is-hidden');
		$resultImg.addClass('is-hidden');
		$test.addClass('is-start');
		gsap.killTweensOf([$start, $step, $result]);
		gsap.set([$start, $step, $result], {clearProps: 'all'});

		setUrlParam(true);
	}

	function reload() {
		gsap.timeline({
			onComplete: reset,
		})
			.to($result, 0.3, {
				opacity: 0,
			})
			.call(() => {
				$result.addClass('is-hidden');
				$start.removeClass('is-hidden');

				gsap.killTweensOf($result);
				gsap.set($result, {clearProps: 'all'});
			})
			.from([$start], 0.3, {
				opacity: 0,
			});

		$document.trigger('test-reload');
	}

	function result() {
		let answersNumber = sumResult(answers);
		if ('ga' in window) {
			ga('send', 'event','TestEQ','endEQ');
		}
		const resultIndex = getResultIndex(answersNumber);
		const $lastStep = $step.last();
		const $activeResultTitle = $resultTitle.eq(resultIndex);
		const $activeResultText = $resultText.eq(resultIndex);
		const $activeSubTitleResult = $subTitleResult.eq(resultIndex);
		const $activeSubTextResult = $subTextResult.eq(resultIndex);
		const $activeImgResult = $resultImg.eq(resultIndex);

		$activeResultTitle.removeClass('is-hidden');
		$activeResultText.removeClass('is-hidden');
		$activeSubTitleResult.removeClass('is-hidden');
		$activeSubTextResult.removeClass('is-hidden');
		$activeImgResult.removeClass('is-hidden');

		if ($resultImg.attr('id') === $activeImgResult) {
			$resultImg.removeClass('is-hidden');
		}

		gsap.timeline()
			.to([$lastStep], 0.3, {
				opacity: 0,
			})
			.call(() => {
				$lastStep.addClass('is-hidden');
				$result.removeClass('is-hidden');

				gsap.killTweensOf([$lastStep]);
				gsap.set([$lastStep], {clearProps: 'all'});
			})
			.from([$result], 0.3, {
				opacity: 0,
			})
			.from([$('.test__result-center')], 0.3, {
				opacity: 0,
				onComplete: () => {
					$resultImg.removeClass('is-view');
					$resultBottom.removeClass('is-view');

					gsap.timeline().from($resultImg, 1, {
						y: $resultImg.height() / 2,
					});
					gsap.timeline().from($resultBottom, 1, {
						y: -$resultBottom.height() / 2,
					});
				},
			});
		setUrlParam();
	}

	function setInvert(step, answer) { // функция для изменения шкалы ответров в обратную стороу от 5 до 1, на нужных вопросах
		if (step === 1 || step === 3 || step === 6 || step === 8) {
			if (answer === 1) {
				return 5;
			} else if (answer === 2) {
				return 4;
			} else if (answer === 4) {
				return 2;
			} else if (answer === 5) {
				return 1;
			}

			return answer;
		}

		return answer;
	}

	function next(event) {
		const $currentStep = $(event.currentTarget).closest('.test__step');
		const $nextStep = $currentStep.next('.test__step');

		let num = setInvert($currentStep.data('index') + 1, $currentStep.find('.test__slider').data('answer'));

		answers.push(num);

		$('html, body').animate({
			scrollTop: 0,
		}, 500);

		if (!$nextStep.length) {
			result();

			return;
		}

		gsap.timeline()
			.to([$currentStep.find('.test__variants'), $currentStep.find('.test__button')], 0.5, {
				y: -200,
			})

			.call(() => {
				$currentStep.addClass('is-hidden');
				$nextStep.removeClass('is-hidden');
				$currentStep.next().find('.test__question').height($currentStep.next().find('.test__question').height()); // фикс, что бы анимация текста не изменяла высоту блока
				wordAnimation($currentStep.next().find('.test__question'));
				gsap.killTweensOf($currentStep);
				gsap.set($currentStep, {clearProps: 'all'});
			})
			.from([$currentStep.next().find('.test__variants'), $currentStep.next().find('.test__button')], 0.5, {
				y: -200,
			});
	}

	function answer(event) {
		const $currentStep = event.closest('.test__step');

		$currentStep.addClass('is-done');
	}

	function start() {
		slider();
		$test.removeClass('is-start');
		$('.next-container').first().css('background-color', '#EEEEEE');
		// console.log('apply style');
		const $firstStep = $step.first();
		if ('ga' in window) {
			ga('send', 'event','TestEQ','startEQ');
		}
		const stepIndex = $firstStep.data('index');
		const question = $firstStep.find('.test__question').text();

		$('html, body').animate({
			scrollTop: 0,
		}, 500);

		gsap.timeline()
			.to($start, 0.3, {
				opacity: 0,
				clearProps: 'all',
			})
			.call(() => {
				$start.addClass('is-hidden');
				$firstStep.removeClass('is-hidden');
				$firstStep.find('.test__question').height($firstStep.find('.test__question').height()); // фикс, что бы анимация текста не изменяла высоту блока
				wordAnimation($firstStep.find('.test__question'));
				gsap.killTweensOf($start);
				gsap.set($start, {clearProps: 'all'});
			})
			.from($firstStep, 0.3, {
				opacity: 0,
				clearProps: 'all',
			});

		$document
			.trigger('test-start')
			.trigger('test-question-show', [stepIndex + 1, question]);
	}

	function slider() {
		let $slider = document.querySelectorAll('.test__slider');

		for (let i = 0; i < $slider.length; i++) {
			noUiSlider.create($slider[i], {
				range: {
					min: 1,
					max: 5,
				},
				start: [3],
			});

			$slider[i].noUiSlider.on('update', (values) => {
				const currentQuestion = answers.length + 1;
				if ([1, 3, 6, 8].includes(currentQuestion)) {
					if (values <= 1.8) {
						$slider[i].setAttribute('data-answer', 5);
					} else if (values > 1.8 && values <= 2.6) {
						$slider[i].setAttribute('data-answer', 4);
					} else if (values > 2.6 && values <= 3.4) {
						$slider[i].setAttribute('data-answer', 3);
					} else if (values > 3.4 && values <= 4.2) {
						$slider[i].setAttribute('data-answer', 2);
					} else {
						$slider[i].setAttribute('data-answer', 1);
					}
				} else {
					if (values <= 1.8) {
						$slider[i].setAttribute('data-answer', 1);
					} else if (values > 1.8 && values <= 2.6) {
						$slider[i].setAttribute('data-answer', 2);
					} else if (values > 2.6 && values <= 3.4) {
						$slider[i].setAttribute('data-answer', 3);
					} else if (values > 3.4 && values <= 4.2) {
						$slider[i].setAttribute('data-answer', 4);
					} else {
						$slider[i].setAttribute('data-answer', 5);
					}
				}
			});
		}
	}

	$step.find('.test__description').on('click', (e) => {
		let $this = $(e.currentTarget);

		let $animation = $this.closest('.test__step').find('.test__option, .test__description-close');
		$this.slideUp();
		$animation.slideDown();
	});

	$closeDescription.on('click', (e) => {
		let $this = $(e.currentTarget);

		let $animation = $this.closest('.test__step').find('.test__option, .test__description-close');
		$('.test__description').slideDown();
		$animation.slideUp();
	});

	$startButton.on('click', start);
	$answerButton.on('click', answer);
	$nextButton.on('click', next);
	$reloadButton.on('click', reload);
}

$('.test__article-text').on('click', () => {
	if ('ga' in window) {
		ga('send', 'event','TestEQ','buttonEQ');
	}
})

test();
